module.exports = [{
      plugin: require('../node_modules/gatsby-plugin-manifest/gatsby-browser.js'),
      options: {"plugins":[],"name":"Abramski","short_name":"abramski","start_url":"/","background_color":"#F9F9F9","theme_color":"#463C3C","display":"minimal-ui","icon":"src/assets/images/icon.png"},
    },{
      plugin: require('../gatsby-browser.js'),
      options: {"plugins":[]},
    }]
